<template>
  <router-view />
</template>

<script>
export default {
  name: 'DayTripsIndex'
}
</script>
